import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  acceptInvitation,
  rejectInvitation,
} from "../Redux/actions/Useraction";

const InvitationPage = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const token = searchParams.get("token");

  const handleAccept = async () => {
    setLoading(true);
    const res = await dispatch(acceptInvitation(token));
    setMessage(res?.message || "Something went wrong");
    setLoading(false);
  };

  const handleReject = async () => {
    setLoading(true);
    const res = await dispatch(rejectInvitation(token));
    setMessage(res?.message || "Something went wrong");
    setLoading(false);
  };

  if (!token) return <p>Invalid invitation link</p>;

  return (
    <div>
      <h2>Patient Invitation</h2>
      {message ? (
        <p>{message}</p>
      ) : (
        <>
          <button onClick={handleAccept} disabled={loading}>
            Accept
          </button>
          <button onClick={handleReject} disabled={loading}>
            Reject
          </button>
        </>
      )}
    </div>
  );
};

export default InvitationPage;
